<template>
  <div class="enterprise">
    <ContentView>
      <template slot="contentBox">
        <div class="detail-form-box" style="width:50%">
        <el-form class="notice-form" :model="form" label-position="top" :disabled="urlData.id?true:false">
            <el-form-item label="标题" >
                <el-input v-model="form.title" autocomplete="off" ></el-input>
            </el-form-item>
            <el-form-item label="内容" >
                <el-input  type="textarea" :rows="6" v-model="form.content" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="选择企业" >
                <!-- <el-input v-model="form.pushUser" autocomplete="off"></el-input> -->
                <el-select style="width:100%;" v-model="form.OrgCodes" multiple placeholder="请选择">
                  <el-option
                    v-for="item in orgList"
                    :key="item.orgCode"
                    :label="item.orgName_Short"
                    :value="item.orgCode">
                  </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="发布时间" >
                <el-date-picker
                v-model="form.pushTime"
                type="datetime"
                placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item> -->
        </el-form>
        </div>
      </template>
      <template slot="pagnation" v-if="!urlData.id" >
            <div >
                <el-button @click="onClose">取 消</el-button>
                <el-button style="color:#fff" type="primary" @click="onSave">确 定</el-button>
            </div>
        </template>
    </ContentView>

  </div>
</template>

<script>
import ContentView from "@/components/ContentView";
import apiPub from '@/api/public'
import { mapGetters } from "vuex";
export default {
  name: "enterprise",
  data() {
    return {
      tableData: [],
      searchVal:"",
      options:[],
      dialogFormVisible:false,
      form:{
        title:"",
        content:"",
        OrgCodes:[]
      },
      input:"",
      win: false,
      value: "",
      searchVal:"",
      orgList:[],
      page:1,
      total:0,
      timesRun: 0
    };
  },
  components: {
    ContentView
  },
  created() {
    this.urlData = this.$router.currentRoute.query;
    if(this.urlData.id){
        this.load();
    }
    this.onSearch();
   
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    //---------------查询区域--------begin-----------
   
    load() {
      var that = this;
      var obj = {
        url: apiPub.GetNoticeId,
        data: {
          id: this.urlData.id
        }
      };
      $http.request(obj, false, function(res) {
        // console.log(res);
        if (res.code == 200) {
          that.form = res.data;
        }
      });
    },
    onSearch(){
      this.page = 1;
      this.total = 0;
      this.getlist()
    },
    // GetNoticeId
    getlist(){
      var that=this;
      var SearchText=this.searchVal||""
      var obj = {
        "url": apiPub.GetAllEnterprise,
        "data":{
          pageNum: that.page - 1,
          pageSize: 10000,
          SearchText:SearchText,
          // OrdFild:that.OrdFild,
          // OrdSort:that.OrdSort
        }
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
        that.orgList=res.data;
        // that.total=res.totalNum;
      })
    },
    //---------------业务区域--------end-----------
    onClose() {
      this.$router.back(-1);
    //   this.$router.push({ name: 'enterprise'});
    },
    onSave(){
      var that=this;
      var SearchText=this.searchVal||""
      console.log(this.form)
      var obj = {
        "url": apiPub.AddNotice,
        "data":{
          "Content":this.form.content,
          "Nstate":"0",
          "PushTime":this.form.pushTime,
          "OrgCodes":this.form.OrgCodes,
          "PushUser":this.currentUser.id,
          "Title":this.form.title
        }
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
           that.$message({
                message: '保存成功',
                type: 'success'
            });
            that.onClose()
        // that.tableData=res.data;
      })
    },
    //---------------表格操作--------begin-----------
    
    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  }
};
</script>
<style scoped>
.notice-form /deep/ .el-form-item__label{
    padding: 0;
    margin-bottom: 0;
  }
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.enter-input{
    width: 200px;

}
.enter-input+.enter-input{
    margin-left: 15px;
}
.el-form-item{
    margin-bottom: 10px;
}
</style>
